export type Battery = 'available' | 'missing' | 'incompatible';

export type GtmEventParams = {
  energyFix: boolean;
  energyDynamic: boolean;
  priceOptimization: boolean;
  battery: Battery;
};

export const trackEvent = (params: GtmEventParams) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(params);
};
